document.addEventListener('DOMContentLoaded', function () {
  function applyReviewWidgetStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Styles for review widget - design based on Review2.png */

      .jdgm-rev-widg__summary-inner {
          display: flex !important;
          flex-direction: column !important;
          text-align: center !important;
      }
      }
      
      /* Custom container for average number */
      .custom-average-wrapper {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        margin-bottom: 12px !important;
        background-color: transparent !important;
      }
      
      .custom-average-wrapper .jdgm-rev-widg__summary-average, .jdgm-rev-widg__summary-stars  {
        font-size: 48px !important;
        font-weight: bold !important;
        color: #ffffff !important;
        text-align: center !important;
        line-height: 1 !important;
        margin: 0 !important;
        display: block !important;
        order: 0 !important;
      }

      /* Custom container for stars */
      .custom-stars-wrapper {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        margin-bottom: 12px !important;
        gap: 2px !important;
        order: 1 !important;
      }

      .custom-stars-wrapper .jdgm-star {
        color: #ff0000 !important;
        font-size: 15px !important;
        margin: 0 !important;
        line-height: 1 !important;
      }

      .custom-stars-wrapper .jdgm-star--filled,
      .custom-stars-wrapper .jdgm--on {
        color: #ff0000 !important;
      }

      .custom-stars-wrapper .jdgm-star--empty {
        color: #333333 !important;
      }

      /* Hide ALL original stars */
      .jdgm-rev-widg__stars,
      .jdgm-rev-widg__summary .jdgm-star:not(.custom-stars-wrapper .jdgm-star) {
        display: none !important;
      }
      
      /* Hide any star that is not in our custom container */
      .jdgm-rev-widg__summary > .jdgm-star {
        display: none !important;
      }

      /* Review count text */
      .jdgm-rev-widg__summary-text {
        color: #ffffff !important;
        font-size: 14px !important;
        text-align: center !important;
        order: 4;
      }

      /* Main widget container */
      .jdgm-rev-widg__summary {
        background-color: transparent !important;
        text-align: center !important;
        padding: 20px !important;
      }
    `;

    document.head.appendChild(style);

    // Function to create custom containers
    function createCustomWrappers() {
      // Find Judge.me widget elements
      const summaryContainers = document.querySelectorAll('.jdgm-rev-widg__summary');

      summaryContainers.forEach(container => {
        // Check if custom containers have already been created
        if (container.querySelector('.custom-average-wrapper') || container.querySelector('.custom-stars-wrapper')) {
          return;
        }

        // Find the average element
        const averageElement = container.querySelector('.jdgm-rev-widg__summary-average');

        // Find the stars
        const starElements = container.querySelectorAll('.jdgm-star');

        if (averageElement || starElements.length > 0) {
          // Create container for average number
          if (averageElement && !averageElement.closest('.custom-average-wrapper')) {
            const averageWrapper = document.createElement('div');
            averageWrapper.className = 'custom-average-wrapper';

            // Insert wrapper before the average element
            averageElement.parentNode.insertBefore(averageWrapper, averageElement);

            // Move the average element to the wrapper
            averageWrapper.appendChild(averageElement);
          }

          // Create container for stars
          if (starElements.length > 0) {
            const starsWrapper = document.createElement('div');
            starsWrapper.className = 'custom-stars-wrapper';

            // Insert wrapper after average or at the beginning
            const averageWrapper = container.querySelector('.custom-average-wrapper');
            if (averageWrapper) {
              averageWrapper.parentNode.insertBefore(starsWrapper, averageWrapper.nextSibling);
            } else {
              container.insertBefore(starsWrapper, container.firstChild);
            }

            // Move all stars to the new container
            starElements.forEach(star => {
              if (!star.closest('.custom-stars-wrapper')) {
                const clonedStar = star.cloneNode(true);
                starsWrapper.appendChild(clonedStar);
                // Hide original star
                star.style.display = 'none';
              }
            });

            // Hide any original stars container
            const originalStarsContainer = container.querySelector('.jdgm-rev-widg__stars');
            if (originalStarsContainer) {
              originalStarsContainer.style.display = 'none';
            }
          }
        }
      });
    }

    // Function to apply dynamic styles
    function applyDynamicStyles() {
      // Create containers first
      createCustomWrappers();

      // Apply styles to elements in custom containers
      const averageElements = document.querySelectorAll('.custom-average-wrapper .jdgm-rev-widg__summary-average');
      averageElements.forEach(element => {
        element.style.fontSize = '48px';
        element.style.fontWeight = 'bold';
        element.style.color = '#ffffff';
        element.style.textAlign = 'center';
        element.style.lineHeight = '1';
        element.style.margin = '0';
      });

      const starElements = document.querySelectorAll('.custom-stars-wrapper .jdgm-star');
      starElements.forEach(element => {
        element.style.fontSize = '16px';
        element.style.margin = '0';
        element.style.lineHeight = '1';
        element.style.display = 'inline-block';
        if (element.classList.contains('jdgm-star--filled') || element.classList.contains('jdgm--on')) {
          element.style.color = '#ff0000';
        } else {
          element.style.color = '#333333';
        }
      });

      // Hide original stars that may be outside our containers
      const originalStars = document.querySelectorAll('.jdgm-rev-widg__summary .jdgm-star:not(.custom-stars-wrapper .jdgm-star)');
      originalStars.forEach(star => {
        if (!star.closest('.custom-stars-wrapper')) {
          star.style.display = 'none';
        }
      });

      // Find summary text
      const summaryTextElements = document.querySelectorAll('.jdgm-rev-widg__summary-text');
      summaryTextElements.forEach(element => {
        element.style.color = '#ffffff';
        element.style.fontSize = '14px';
        element.style.textAlign = 'center';
      });

      // Find main container
      const summaryContainers = document.querySelectorAll('.jdgm-rev-widg__summary');
      summaryContainers.forEach(container => {
        container.style.backgroundColor = 'transparent';
        container.style.textAlign = 'center';
        container.style.padding = '20px';
      });
    }

    // Apply styles immediately
    setTimeout(applyDynamicStyles, 100);

    // Observer to detect when new widget elements are loaded
    const observer = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('jdgm-rev-widg__summary-average') ||
                node.classList.contains('jdgm-star') ||
                node.classList.contains('jdgm-rev-widg__stars') ||
                node.classList.contains('jdgm-rev-widg__summary-text') ||
                node.classList.contains('jdgm-rev-widg__summary') ||
                node.classList.contains('jdgm-widget')
              )) {
                shouldUpdate = true;
              }
              // Also search within the added node
              if (node.querySelector && (
                node.querySelector('.jdgm-rev-widg__summary-average') ||
                node.querySelector('.jdgm-star') ||
                node.querySelector('.jdgm-rev-widg__stars') ||
                node.querySelector('.jdgm-rev-widg__summary-text') ||
                node.querySelector('.jdgm-rev-widg__summary') ||
                node.querySelector('.jdgm-widget')
              )) {
                shouldUpdate = true;
              }
            }
          });
        }
      });

      if (shouldUpdate) {
        setTimeout(applyDynamicStyles, 200);
      }
    });

    // Start observation
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Re-apply styles periodically in case the widget loads late
    setTimeout(applyDynamicStyles, 1000);
    setTimeout(applyDynamicStyles, 3000);
    setTimeout(applyDynamicStyles, 5000);

    // Additional observer specific for Judge.me
    const judgemeObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target.classList &&
          (mutation.target.classList.contains('jdgm-widget') ||
            mutation.target.classList.contains('jdgm-rev-widg__summary'))) {
          setTimeout(applyDynamicStyles, 300);
        }
      });
    });

    // Find existing widgets and observe them
    setTimeout(() => {
      const widgets = document.querySelectorAll('.jdgm-widget, .jdgm-rev-widg__summary');
      widgets.forEach(widget => {
        judgemeObserver.observe(widget, {
          childList: true,
          subtree: true,
          attributes: true
        });
      });
    }, 1000);
  }

  // Execute when DOM is ready
  applyReviewWidgetStyles();
});